import { cn } from "@/shared/lib/utils";
import { useAppDispatch, useAppSelector } from "@/app/store";
import { selectLanguage, setLanguage } from "@/app/store/slices/ui.slice";
import { clearHelperData } from "@/app/store/slices/purchaseOrders.slice";
import { clearHelperData as clearPreparedItemsHelperData } from "@/app/store/slices/preparedItems.slice";
import { API_TAG_TYPES, baseApi } from "@/app/store/api/base.api";
import { changeLanguage } from "@/app/i18n";
import type { Language } from "@/shared/types";

export function LanguageSwitcher() {
  const dispatch = useAppDispatch();
  const currentLanguage = useAppSelector(selectLanguage);

  const languages: { code: Language; label: string; native: string }[] = [
    { code: "en", label: "English", native: "English" },
    { code: "ar", label: "Arabic", native: "العربية" },
  ];

  const handleLanguageChange = async (lang: Language) => {
    await changeLanguage(lang);
    dispatch(setLanguage(lang));
    dispatch(clearHelperData());
    dispatch(clearPreparedItemsHelperData());
    dispatch(baseApi.util.invalidateTags([...API_TAG_TYPES]));
  };

  return (
    <div className="flex items-center rounded-lg border border-grey-100 overflow-hidden">
      {languages.map((lang) => (
        <button
          key={lang.code}
          onClick={() => handleLanguageChange(lang.code)}
          className={cn(
            "px-3 py-1.5 text-sm font-bold transition-colors",
            currentLanguage === lang.code
              ? "bg-grey-50 text-black"
              : "bg-white text-grey-300 hover:bg-grey-50 hover:text-grey-900"
          )}
        >
          {lang.native}
        </button>
      ))}
    </div>
  );
}
